import { AudiencePersonalizationSettings } from '@/components/settings/AI/AudiencePersonalizationSettings';
import { BrandVoiceSettings } from '@/components/settings/AI/BrandVoiceSettings';
import { ContentRulesSettings } from '@/components/settings/AI/ContentRulesSettings';
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from '@superfunnel/ui-core/v2/Tabs';
import { Megaphone, Settings, User } from 'iconoir-react';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function AiSettings() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedSubTab, setSelectedSubTab] = useState<string>(
    searchParams.get('tab') || 'brand_voice',
  );

  const subTabs = useMemo(
    () =>
      [
        {
          id: 'brand_voice',
          icon: <Megaphone className={'text-base-500 size-5'} />,
          name: 'Brand & Voice',
          current: false,
        },
        {
          id: 'audience',
          icon: <User className={'text-base-500 size-5'} />,
          name: 'Audience',
          current: false,
        },
        {
          id: 'content_rules',
          icon: <Settings className={'text-base-500 size-5'} />,
          name: 'Content Rules',
          current: false,
        },
      ].map((c) => {
        c.current = c.id === selectedSubTab;
        return c;
      }),
    [selectedSubTab],
  );

  useEffect(() => {
    setSearchParams((prev) => {
      prev.set('tab', selectedSubTab);
      return new URLSearchParams(prev);
    });
  }, [selectedSubTab, setSearchParams]);

  return (
    <Tabs
      defaultValue={selectedSubTab}
      onValueChange={setSelectedSubTab}
      orientation={'vertical'}
      className="grid h-full w-full grid-cols-1 gap-6 overflow-hidden bg-transparent md:grid-cols-[200px_1fr]"
    >
      <TabsList
        className={
          'h-min w-full flex-wrap items-start justify-start p-0 md:sticky md:top-0 md:flex-col'
        }
      >
        {subTabs.map((tab) => (
          <TabsTrigger
            value={tab.id}
            key={tab.id}
            className={
              'data-[state=active]:bg-base-100 h-auto flex-none justify-start gap-2.5 p-2 data-[state=active]:shadow-none md:w-full'
            }
          >
            {tab.icon} {tab.name}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="brand_voice" className={'h-full overflow-y-auto'}>
        <BrandVoiceSettings />
      </TabsContent>
      <TabsContent value="audience" className={'h-full overflow-y-auto'}>
        <AudiencePersonalizationSettings />
      </TabsContent>
      <TabsContent value="content_rules" className={'h-full overflow-y-auto'}>
        <ContentRulesSettings />
      </TabsContent>
    </Tabs>
  );
}
